module.exports = __webpack_public_path__ + "img/page-03.999f9790.png";